import React from "react";

import { StyledBadge, StyledBadgeProps } from "./styles";

type BadgeProps = StyledBadgeProps;

export const Badge: React.FC<BadgeProps> = ({ children, ...rest }) => {
  return <StyledBadge {...rest}>{children}</StyledBadge>;
};
